import { addResourceBundle } from '@egw/i18n'
import en from './src/i18n/locales/en.json'

addResourceBundle('en', 'features-auth', en)

export * from './src/components/add-icon/add-icon'
export * from './src/components/idle-recovery/idle-recovery'
export * from './src/components/idle-timer/idle-timer'
export * from './src/components/idle-timer-enrollment/idle-timer-enrollment'
export * from './src/components/front-id/front-id'
export * from './src/components/back-id/back-id'
export * from './src/components/process-id/process-id'
export * from './src/components/selfie/selfie'
export * from './src/components/face-match/face-match'
export * from './src/components/retry-steps/retry-steps'
export * from './src/components/reset-permissions/reset-permissions'
export * from './src/components/mobile-redirect/mobile-redirect'
export * from './src/components/consent/consent'
export * from './src/hooks/doc-v'
export * from './src/models/index'
export * from './src/constants'
export * from './src/pages/application-under-review'
export * from './src/pages/browser-error'
export * from './src/pages/passkey'
export * from './src/pages/passkey-details'
export * from './src/pages/recovery'
export * from './src/pages/recovery/email'
export * from './src/pages/recovery/magic-link'
export * from './src/pages/recovery/method'
export * from './src/pages/recovery/passkey'
export * from './src/pages/recovery/phone'
export * from './src/pages/recovery/phone-otp'
export * from './src/pages/recovery/problem'
export * from './src/pages/recovery/review'
export * from './src/pages/recovery/verification'
export * from './src/pages/sign-in'
export * from './src/pages/sign-in-challenge'
export * from './src/pages/sign-in-challenge-fail'
export * from './src/pages/re-entry/expired'
export * from './src/pages/re-entry/verify-email'
export * from './src/pages/re-entry/enter-phone'
export * from './src/pages/re-entry/verify-phone'
export * from './src/pages/re-entry/welcome-back'
export * from './src/components/feature-guard'
